import React from "react";
import {
  CAccordion,
  CAccordionBody,
  CAccordionHeader,
  CAccordionItem,
} from "@coreui/react";

const CustomAccordion = ({ datas }) => {
  return (
    <CAccordion alwaysOpen activeItemKey={0} >
      {datas.map((item, i) => {
        return (
          <CAccordionItem itemKey={i} key={i}>
            <CAccordionHeader>{item.question}</CAccordionHeader>
            <CAccordionBody>{item.answer}</CAccordionBody>
          </CAccordionItem>
        );
      })}
    </CAccordion>
  );
};

export default CustomAccordion;
